import RequestForm from "../../../../core/model2/form/request-form"
import {RequestFormType} from "../const/const"
import DatetimeUtils from "../../../../core/gd/utils/datetime-utils"
import {prepareSubmissionData} from "./prepare-submission-data"
import {MandatoryFieldsIds} from "../@const"

// const debug = "prepareFormDataForSharedViewSubmission"
const debug = false

export default function prepareFormDataForSharedViewSubmission(requestForm:RequestForm, result:any) {

    debug && console.log(debug, 'process', requestForm, result)

    const task: any = {}

    const formFields:any    = []
    let fromName            = ''
    let fromEmail           = ''

    switch (requestForm.type) {
        case RequestFormType.FORM:
            const nameFieldId = requestForm.settings.nameField?.field?.fieldId
            if (nameFieldId) fromName = result[nameFieldId]

            const emailFieldId = requestForm.settings.emailField?.field?.fieldId
            if (emailFieldId) fromEmail = result[emailFieldId]
            break
    }

    // REQUIRED TITLE FIELD
    task.title = result[MandatoryFieldsIds.TITLE]

    debug && console.log(debug, 'process fields', requestForm.settings.fields)

    prepareSubmissionData(requestForm, task, formFields, result)

    //hotfix (otherwise message 'scheduleDate: "unconverted data remains: T21:00:00.000Z"' is received
    if (task.scheduleDate) {
        task.scheduleDate = DatetimeUtils.momentToDate(DatetimeUtils.datetimeToMoment(task.scheduleDate))
    }

    if (task.startDate) task.startDate  = DatetimeUtils.momentToDate(DatetimeUtils.datetimeToMoment(task.startDate))
    if (task.endDate)   task.endDate    = DatetimeUtils.momentToDate(DatetimeUtils.datetimeToMoment(task.endDate))
    if (task.deadline)  task.deadline   = DatetimeUtils.momentToDate(DatetimeUtils.dateToMoment(task.deadline))

    debug && console.log(debug, 'result', {
        task        : task,
        formFields  : formFields,
        fromName    : fromName,
        fromEmail   : fromEmail
    })

    return {
        task        : task,
        formFields  : formFields,
        fromName    : fromName,
        fromEmail   : fromEmail
    }
}